import { Descriptions } from "antd";
import { EntityManager } from "../../components/entityManager";
import { enmControlType, enmPropertyType, IMetadata } from "../../components/entityManager/interfaces";
import { ComparisonFilter } from "../../components/infrastructure/filtering";
import { Brand } from "../brand";
import { EquipmentItem } from "../equipment/equipmentItem";
import { IEquipmentItemProps } from "../equipment/interfaces";
import { Center } from "../center";
import { IEvaluatorEquipment, IEvaluatorEquipmentProps, IEvaluatorEquipmentStates } from "./interfaces";
import { ICenterProps } from "../center/interfaces";

export class EvaluatorEquipment extends EntityManager<IEvaluatorEquipment, IEvaluatorEquipmentProps, IEvaluatorEquipmentStates>{

    static initMetadata = (): IMetadata => {
        return {
            title: "تجهیزات مجاز ارزیابی",
            name: "EvaluatorEquipment",
            Properties: [
                {
                    title: "ارزیاب",
                    dataIndex: "EvaluatorId",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.lookup,
                    filterable: true,
                    width: 200,
                    rules: [{ required: true, message: 'لطفا ارزیاب را وارد نمایید' }],
                    lookup: {
                        lookupComponent: Center,
                        lookupProperty: "Evaluator",
                        lookupDisplayFields: ["FullName"]
                    }
                },
                {
                    title: "تجهیز",
                    dataIndex: "EquipmentId",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.lookup,
                    filterable: true,
                    width: 200,
                    rules: [{ required: true, message: 'لطفا تجهیز را وارد نمایید' }],
                    lookup: {
                        lookupComponent: EquipmentItem,
                        lookupProperty: "Equipment",
                        lookupDisplayFields: ["Name"]
                    }
                },
                {
                    title: "برند",
                    dataIndex: "BrandId",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.lookup,
                    filterable: true,
                    width: 200,
                    rules: [{ required: true, message: 'لطفا برند را وارد نمایید' }],
                    lookup: {
                        lookupComponent: Brand,
                        lookupProperty: "Brand",
                        lookupDisplayFields: ["Name"]
                    }
                }
            ]
        };
    }

    onInitializing() {
        this.searchArea = { columnsPerRow: 2 };
        this.searchable = true;

        this.preparelookupProps = (propName, lookupProps: any) => {
            if (propName === "EvaluatorId")
                (lookupProps as ICenterProps).isEvaluator = true;

            if (propName === "EquipmentId")
                (lookupProps as IEquipmentItemProps).params = () => {
                    return { onlySubItems: true }
                };

            return lookupProps;
        };

        this.originalFilter = () => {
            if (this.props.params && this.props.params()?.evaluator) {
                return ComparisonFilter.Equal<IEvaluatorEquipment>(m => m.EvaluatorId, this.props.params && this.props.params()?.evaluator?.Id);
            }
        };
        this.extraHeaderNodes = () => {
            return (
                <Descriptions className="header-page">
                    <Descriptions.Item label="مرکز ارزیابی">{this.props.params && this.props.params().evaluator?.FullName}</Descriptions.Item>
                </Descriptions>
            );
        };
        this.onEntityAdded = (entity) => {
            let evaluator = this.props.params && this.props.params().evaluator
            if (evaluator) {
                entity.EvaluatorId = evaluator.Id;
                entity.Evaluator = evaluator;
                entity.ModifiedProperties.push("EvaluatorId");
            }
            return true;
        };
    }
}